import { TRAINING_PRODUKTE, type ProduktKey } from "@nl/shared"
const labels: Record<ProduktKey, string> = {
  aktivplan: "Aktivplan",
  basisrente: "Basisrente",
  berufsunfaehigkeit: "Einkommensschutz",
  foerderrente: "Förderrente",
}
export const productMedia = TRAINING_PRODUKTE.map((product) => ({
  ...product,
  title: labels[product.key],
  image: `/mediathek/produkt-${product.key}.jpg`,
}))

/**
 * The shell and the page must agree on this: an unavailable key renders the
 * picker, and a layout derived from the bare key would clip it.
 */
export function availableProduct(key: string | undefined) {
  const product = productMedia.find((entry) => entry.key === key)
  return product?.available ? product : undefined
}
